const assetTypes = {
	DEDICATED: 'dedicated',
	DOMAIN: 'dreg',
	DNS: 'dns',
	SSL: 'ssl',
	ALL: 'ALL',
};

export default assetTypes;
